/**
 * Environment variables template
 */

export function getEnvTemplate(): string {
  return `# Vibeship DevTools Environment Variables
# Generated by: npx vibeship init

# Security Settings
# Disable file writes in production
VIBESHIP_DISABLE_FILE_WRITES=false

# API Configuration
NEXT_PUBLIC_VIBESHIP_API_PATH=/api/vibeship
VIBESHIP_API_TIMEOUT=30000

# AI Provider API Keys (optional)
# Add your API keys here for AI features
# OPENAI_API_KEY=sk-...
# ANTHROPIC_API_KEY=sk-ant-...
# GOOGLE_AI_API_KEY=...

# Feature Flags
NEXT_PUBLIC_VIBESHIP_FEATURE_AI=true
NEXT_PUBLIC_VIBESHIP_FEATURE_TASKS=true
NEXT_PUBLIC_VIBESHIP_FEATURE_FILE_EDITING=true

# Security - Allowed paths for file operations
VIBESHIP_ALLOWED_PATHS=./src,./app,./pages,./components,./docs

# Cache Settings
VIBESHIP_CACHE_ENABLED=true
VIBESHIP_CACHE_TTL=3600000

# Development Settings
VIBESHIP_DEV_MODE=true
VIBESHIP_DEBUG=false
`;
}

export function getEnvExampleTemplate(): string {
  return `# Example environment variables for Vibeship DevTools
# Copy this file to .env.local and add your values

# AI Provider API Keys
OPENAI_API_KEY=your-openai-api-key
ANTHROPIC_API_KEY=your-anthropic-api-key
GOOGLE_AI_API_KEY=your-google-ai-api-key

# Security
VIBESHIP_DISABLE_FILE_WRITES=true  # Set to true in production

# Custom API path (if different from default)
NEXT_PUBLIC_VIBESHIP_API_PATH=/api/vibeship
`;
}